export default class IdListDTO {
  idList: string[] | undefined;

  constructor(idList: string[]) {
    this.idList = idList;
  }
}
